import { I18N } from "../I18N"
import { OrderHelper } from "../OrderHelper"

export class Order {

	constructor(id) {
		this._id = id
	}

	setTasks = tasks => {
		this._tasks = tasks.map(task => { return { id: task.id, name: task.name, key: task.taskDefinitionKey } })
		this._taskPriority = this._tasks.some(task => task.name === 'Drucken') ? 10 :  this._tasks.some(task => task.name === 'Eingang') ? 20 :  this._tasks.some(task => task.name === 'Zubereiten') ? 30 : 40
	}

	setVariables = variables => {
		this._receiveDateTime = new Date(variables.receiveDateTime.value)
		this._startCookingDateTime = variables.startCookingDateTime.value ? new Date(variables.startCookingDateTime.value) : null
		this._cookingStartedDateTime = (variables.cookingStartedDateTime && variables.cookingStartedDateTime.value) ? new Date(variables.cookingStartedDateTime.value) : null
		this._deliveryDateTime = new Date(variables.deliveryDateTime.value)
		this._contact = variables.contact.value ? JSON.parse(variables.contact.value) : null
		this._delivery = variables.delivery.value
		this._deliveryAddress = variables.deliveryAddress.value ? JSON.parse(variables.deliveryAddress.value) : null
		this._storeId = variables.storeId.value
		this._storeContact = variables.storeContact.value ? JSON.parse(variables.storeContact.value) : null
		this._cart = variables.cart.value ? JSON.parse(variables.cart.value) : null
		this._net = variables.net.value
		this._tax = variables.tax.value
		this._payment = variables.payment.value ? JSON.parse(variables.payment.value) : null
		this._remarks = variables.remarks.value
		this._discounts = variables.discounts && variables.discounts.value ? JSON.parse(variables.discounts.value) : null
		this._fees = variables.fees && variables.fees.value ? JSON.parse(variables.fees.value) : null
		this._invoiceNumber = variables.invoiceNumber ? variables.invoiceNumber.value : null
	}

	getIdString = () => this._id.substring(0, 8)

	getReceiveDateTimeString = includeTodyDate => this._formatDateTime(this._receiveDateTime, includeTodyDate)

	getStartCookingDateTime = includeTodyDate => this._startCookingDateTime 
		? (
			this._startCookingDateTime < new Date() 
			? (
				this._cookingStartedDateTime 
				? '' 
				: I18N.translate('now')
			) 
			: this._formatDateTime(this._startCookingDateTime, includeTodyDate)
		) 
		: this._cookingStartedDateTime ? '' : I18N.translate('now')

	isDelivery = () => this._delivery === 'delivery'

	getDeliveryDateTime = includeTodyDate => this._formatDateTime(this._deliveryDateTime, includeTodyDate)

	getCustomerNameString = () => `${this._contact.firstName} ${this._contact.lastName}`

	getCustomerPhone = () => this._contact.phone

	getStoreId = () => this._storeId

	getStoreName = () => this._storeContact.company

	getCart = () => this._cart

	getCartItemsLabel = () => OrderHelper.renderLabel(this)

	getPrice = () => this._formatPrice(this._net + this._tax)

	getTax = () => this._formatPrice(this._tax)

	getPaymentMethod = () => this._payment.payWith

	// 'cash' beim Checkout heißt nur "bezahlt bei Übergabe" - ob es dann Bargeld
	// oder EC war, weiß erst das Personal bei Annahme/Lieferung (siehe Counter.js)
	isPayAtHandover = () => this._payment.payWith !== 'paypal'

	setPaymentMethod = payWith => this._payment.payWith = payWith

	getDeliveryAddressString = () => this.isDelivery() ? `${this._deliveryAddress.street} ${this._deliveryAddress.nr}, ${this._deliveryAddress.postalCode} ${this._deliveryAddress.city}` : 'Abholung'

	getShortDeliveryAddressString = () => this.isDelivery() ? `${this._deliveryAddress.street} ${this._deliveryAddress.nr}, ${this._deliveryAddress.postalCode} ${this._getShortCityName(this._deliveryAddress.city)}` : 'Abholung'

	// TODO Geo Pos

	getDoorbell = () => this.isDelivery() ? this._deliveryAddress.doorbell : null

	getRemarks = () => this._remarks

	getDiscounts = () => this._discounts

	getFees = () => this._fees

	getTasks = () => this._tasks

	setCancelled = cancelled => this._cancelled = cancelled

	isCancelled = () => this._cancelled === true

	setSelfCancelled = selfCancelled => this._selfCancelled = selfCancelled

	wasSelfCancelled = () => this._selfCancelled === true

	wasAccepted = () => !this._tasks.some(task => task.key === 'inbox')

	getInvoiceNumber = () => this._invoiceNumber ? String(this._invoiceNumber % 10000).padStart(4, '0') : null

	_formatDateTime = (date, includeTodyDate) => {
		if (!includeTodyDate && new Date().getDate() === date.getDate()) {
			return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
		}
		else {
			return `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${includeTodyDate ? String(date.getFullYear()) : ''} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
		}
	}

	_formatPrice = number => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(number).replace(' ', '')

	_getShortCityName = name => name.match(/\w*(Bremen)\w*/i) === null ? name : 'HB'

}